import React from "react";
import { logMetric } from "./collector";

/**
 * lazyWithPerf - wraps a dynamic import and logs module load duration
 * usage: const Foo = lazyWithPerf(() => import("../Foo"), "Foo");
 */
export function lazyWithPerf<T extends { default: React.ComponentType<any> }>(
  importer: () => Promise<T>,
  name: string,
) {
  return React.lazy(async () => {
    const start = Date.now();
    const module = await importer();
    try {
      logMetric({
        type: "lazy-load",
        name,
        duration: Date.now() - start,
        timestamp: Date.now(),
      });
    } catch {
      // ignore telemetry failures
    }
    return module;
  });
}
